import { Injectable, Output, EventEmitter } from "@angular/core";
declare var jquery: any;
declare var $: any;
@Injectable()
export class AuthorizePPService {
  @Output() change: EventEmitter<any> = new EventEmitter();
  UnAuthorize() {
    this.change.emit({ status: true });
  }
}


// WEBPACK FOOTER //
// ./src/app/authorizePP/authorizePP.service.ts